<template>
  <nav class="pagination columns is-centered" role="navigation" aria-label="pagination">
    <div class="column is-paddingless is-3 has-text-weight-bold has-text-grey is-size-7 has-text-left">
      {{printPageCount}} of  {{totalCount }} Record(s)
    </div>
    <div class="column is-paddingless">
      <ul class="pagination-list">
        <li>
          <router-link
            :to="buildPageLink($route.name, currentPage - 1)"
            class="pagination-previous"
            :class="isActive(firstPage)"
            :disabled="currentPage === firstPage"
          >
            Previous
          </router-link>
        </li>

        <li>
          <router-link
            :to="buildPageLink($route.name, firstPage)"
            class="pagination-link"
            :class="isActive(firstPage)"
          >
            {{ this.firstPage }}
          </router-link>
        </li>

        <li v-for="page in middlePages" :key="page.pageNumber">
          <span v-if="page.ellipsis" class="pagination-ellipsis">&hellip;</span>
          <router-link
            v-else
            class="pagination-link"
            :to="buildPageLink($route.name, page.pageNumber)"
            :class="isActive(page.pageNumber)"
          >
            {{ page.pageNumber }}
          </router-link>
        </li>

        <li v-if="lastPage">
          <router-link
            :to="buildPageLink($route.name, lastPage)"
            class="pagination-link"
            :class="isActive(lastPage)"
          >
            {{ this.lastPage }}
          </router-link>
        </li>

        <li>
          <router-link
            v-if="currentPage !== lastPage && lastPage !== null"
            :to="buildPageLink($route.name, currentPage + 1)"
            class="pagination-next"
            :class="isActive(firstPage, lastPage)"
            :disabled="currentPage === lastPage || lastPage === null"
          >
            Next
          </router-link>
          <a
            v-else
            disabled
            class="pagination-next"
          >
            Next
          </a>
        </li>
      </ul>
    </div>
    <div class="column is-paddingless is-3"></div>
  </nav>
</template>

<script>
export default {
  props: {
    totalCount: {
      type: Number,
      required: true,
      // default: 0,
    },
    pageSize: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      totalPages: null,
      firstPage: null,
      lastPage: null,
      currentPage: 1,
      middlePages: [],
    };
  },
  mounted() {
    this.getCurrentPage();
    this.calculateTotalPages();
    this.setExtremes();
    this.getMiddle();
  },
  computed:{
    printPageCount(){
      const first = (1 + (this.currentPage - 1) * this.pageSize);
      const second = (this.currentPage * this.pageSize);
      if(this.totalCount < second){
        return(first +' - '+ this.totalCount);
      }
      else{
        return(first +' - '+ second);
      }
    },
  },
  methods: {
    buildPageLink(name, page) {
      const { params } = this.$route;
      return {
        name,
        query: Object.assign({}, this.$route.query, { page }),
        params,
      };
    },
    async getCurrentPage() {
      const { page } = this.$route.query;

      if (page) {
        this.currentPage = Number(page);
      }
    },
    isActive(activePage) {
      return {
        'is-current': this.currentPage === activePage,
      };
    },
    calculateTotalPages() {
      this.totalPages = Math.ceil(this.totalCount / this.pageSize);
    },
    setExtremes() {
      this.firstPage = 1;
      if (this.totalPages > 1) {
        this.lastPage = this.totalPages;
      }
    },
    addEllipsisFront() {
      if ((this.middlePages[0].pageNumber - this.firstPage) > 2) {
        this.middlePages.unshift(
          {
            pageNumber: null,
            ellipsis: true,
          },
        );
      } else if (this.middlePages[0].pageNumber - this.firstPage === 2) {
        this.middlePages.unshift(
          {
            pageNumber: (this.firstPage + 1),
            ellipsis: false,
          },
        );
      }
    },
    addEllipsisEnd() {
      if ((this.lastPage - (this.middlePages[this.middlePages.length - 1].pageNumber)) > 2) {
        this.middlePages.push(
          {
            pageNumber: null,
            ellipsis: true,
          },
        );
      } else if ((this.lastPage) - this.middlePages[this.middlePages.length - 1].pageNumber === 2) {
        this.middlePages.push(
          {
            pageNumber: (this.totalPages - 1),
            ellipsis: false,
          },
        );
      }
    },
    getMiddle() {
      // Case 1: get corners (this.firstPage && this.lastPage)
      if (this.currentPage === this.firstPage || this.currentPage === this.firstPage + 1) {
        for (
          let i = this.firstPage + 1;
          i <= this.firstPage + 2 && i < this.lastPage;
          i += 1
        ) {
          this.middlePages.push(
            {
              pageNumber: i,
            },
          );
        }
        if (this.middlePages.length) {
          this.addEllipsisEnd();
        }
      } else if (
        this.currentPage === this.totalPages
        || this.currentPage === this.lastPage - 1
      ) {
        for (
          let i = this.totalPages - 1;
          i >= (this.totalPages - 2) && i > (this.firstPage);
          i -= 1
        ) {
          this.middlePages.unshift(
            {
              pageNumber: i,
            },
          );
        }
        this.addEllipsisFront();
      } else {
        for (let i = this.currentPage - 1; i <= this.currentPage + 1; i += 1) {
          this.middlePages.push(
            {
              pageNumber: i,
            },
          );
        }
        this.addEllipsisFront();
        this.addEllipsisEnd();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .pagination-list  // TODO remove these line
    margin: 0
  .pagination
    margin: 0
  .content li + li
    margin: 0
  a
    color: $primary
    font-weight: 700
    background-color: #fff
    &:hover
      text-decoration: none
    &[disabled]
      cursor: default
  ul
    list-style-type: none
  .pagination-previous:focus,
  .pagination-next:focus,
  .pagination-link:focus
    outline: #716EB4 solid medium
</style>
